import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DashedLabel from '../../atoms/DashedLabel';
import { Link } from 'foundations-components/transitional/components/Link';
import { WarningIcon } from 'foundations-assets';
import styled from 'styled-components';
import { getChannelSettingsUrl } from '../../url/getChannelSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "TicketCreationFailure__Bold",
  componentId: "izsyl2-0"
})(["font-weight:600;"]);
const TicketCreationFailure = ({
  inboxId
}) => {
  const href = getChannelSettingsUrl({
    inboxId
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    "data-test-id": 'ticket-creation-failure-message',
    type: 'error',
    textAlign: 'start',
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'conversations-inbox-message-history.ticket-creation-failure.description_jsx',
      options: {
        href
      },
      elements: {
        WarningIcon,
        Bold,
        Link
      }
    })
  });
};
TicketCreationFailure.displayName = 'TicketCreationFailure';
export default TicketCreationFailure;